export const filter = {
  text: { xl: 6, lg: 7, md: 10, xs: 12 },
  user: { xl: 5, lg: 6, md: 6, xs: 12 },
  dropdown: { xl: 4, lg: 5, md: 7, xs: 12 },
  date: { xl: 3, lg: 4, md: 6, xs: 12 },
  button: { xl: 4, lg: 5, md: 6, xs: 12 },
  find: { xl: 3, lg: 5, md: 5, xs: 12 },
}
